"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindTheGarage() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const schedule = [{
    day: "MON — FRI",
    time: "09:00 — 00:00"
  }, {
    day: "SATURDAY",
    time: "10:00 — 02:00"
  }, {
    day: "SUNDAY",
    time: "12:00 — 22:00"
  }];
  return <section data-section-id="4167" id="find-the-garage" className="bg-background text-foreground py-20 lg:py-28 overflow-hidden">
      <div className="max-w-[1600px] mx-auto">
        {}
        <div ref={headerRef} className={`px-6 lg:px-12 mb-16 lg:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="font-mono text-xs tracking-widest text-primary mb-6">
            SECTION_04 // THE_COORDINATES
          </div>
          <h2 className="font-default font-bold uppercase leading-[0.9] tracking-tighter text-foreground" style={{
          fontSize: "clamp(3.5rem, 8vw, 7rem)"
        }}>
            Find the
            <br />
            Garage.
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0 px-6 lg:px-12 lg:pr-0">
          {}
          <div className="lg:col-span-5 lg:pr-12">
            <div ref={cardRef} className={`transition-all duration-700 delay-100 ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <div className="relative backdrop-blur-none border-2 shadow-lg p-8 lg:p-10 rounded-md" style={{
              background: "var(--card)",
              borderColor: "var(--border)"
            }}>
                {}
                <div className="font-mono text-[10px] tracking-[0.2em] text-primary mb-4">
                  HQ_LOCATION
                </div>
                <p className="font-default font-bold text-foreground leading-none uppercase" style={{
                fontSize: "24px"
              }}>
                  128 Industrial Way,
                  <br />
                  East District, NY 11211
                </p>

                <Separator className="my-8 bg-border" />

                {}
                <div className="font-mono text-[10px] tracking-[0.2em] text-primary mb-3">
                  SIGNAL_LOCK
                </div>
                <p className="font-mono text-sm text-foreground tracking-wider">
                  40.7128° N, 74.0060° W
                </p>

                <Separator className="my-8 bg-border" />

                {}
                <div className="font-mono text-[10px] tracking-[0.2em] text-primary mb-5">
                  SESSION_HOURS
                </div>
                <div className="space-y-3">
                  {schedule.map((item, i) => <div key={i} data-index={i} className="flex items-baseline justify-between gap-4 border-b border-border/50 pb-3 last:border-0 last:pb-0">
                      <span className="font-mono text-xs tracking-widest text-muted-foreground">
                        {item.day}
                      </span>
                      <span className="font-default font-semibold text-base text-foreground">
                        {item.time}
                      </span>
                    </div>)}
                </div>

                {}
                <div className="mt-10">
                  <Link to="#" newTab className="block">
                    <Button size="lg" className="w-full h-14 font-mono text-xs tracking-[0.2em] uppercase bg-primary text-primary-foreground hover:translate-x-1 hover:translate-y-1 transition-transform rounded-md shadow-md group">
                      Get Directions
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </Button>
                  </Link>
                </div>
              </div>

              {}
              <div className="mt-8 space-y-3 font-mono text-xs text-muted-foreground leading-relaxed">
                <div className="flex gap-4">
                  <span className="text-primary shrink-0">→ TRANSIT</span>
                  <span>L-Train to Bedford Ave (6 min walk through the alley)</span>
                </div>
                <div className="flex gap-4">
                  <span className="text-primary shrink-0">→ LOADING</span>
                  <span>Rear bay door access for heavy gear · Free street parking</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            <div ref={mapRef} className={`relative w-full transition-all duration-700 delay-200 ${mapVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`} style={{
            height: "600px"
          }}>
              {}
              <div className="absolute inset-0 overflow-hidden shadow-2xl border-2 border-border rounded-md" style={{
              background: "var(--background)"
            }}>
                {}
                <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: `
                      linear-gradient(var(--border) 1px, transparent 1px),
                      linear-gradient(90deg, var(--border) 1px, transparent 1px)
                    `,
                backgroundSize: "40px 40px"
              }} />
                {}
                <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: `
                      linear-gradient(45deg, transparent 48%, var(--primary) 48%, var(--primary) 52%, transparent 52%),
                      linear-gradient(-30deg, transparent 49%, var(--border) 49%, var(--border) 51%, transparent 51%)
                    `,
                backgroundSize: "150px 150px, 250px 250px"
              }} />
                {}
                <div className="absolute inset-0" style={{
                background: "radial-gradient(circle at 55% 50%, transparent 0%, hsl(220 15% 5% / 0.4) 100%)"
              }} />

                {}
                <div className="absolute" style={{
                top: "48%",
                left: "55%",
                transform: "translate(-50%, -50%)"
              }}>
                  {}
                  <span className="absolute inset-0 -m-6 animate-ping" style={{
                  background: "var(--primary)",
                  opacity: 0.2,
                  width: "48px",
                  height: "48px",
                  animationDuration: "2.5s"
                }} />
                  <span className="absolute inset-0 -m-3 animate-ping" style={{
                  background: "var(--primary)",
                  opacity: 0.3,
                  width: "32px",
                  height: "32px",
                  animationDuration: "2s"
                }} />
                  {}
                  <div className="relative size-4 shadow-lg" style={{
                  background: "var(--primary)",
                  boxShadow: "0 0 20px var(--primary), 0 0 40px var(--primary)"
                }} />
                </div>

                {}
                <div className="absolute top-6 left-6 backdrop-blur-none border-2 shadow-md px-5 py-4 rounded-md" style={{
                background: "var(--card)",
                borderColor: "var(--border)"
              }}>
                  <div className="flex items-center gap-3">
                    <div className="size-3 shrink-0" style={{
                    background: "var(--primary)",
                    boxShadow: "0 0 12px var(--primary)"
                  }} />
                    <div>
                      <div className="font-default font-bold uppercase tracking-tight text-foreground text-base leading-none">
                        THE GARAGE ROOM
                      </div>
                      <div className="font-mono text-[10px] tracking-[0.2em] text-primary mt-1.5">
                        LIVE · TRACKING NOW
                      </div>
                    </div>
                  </div>
                </div>

                {}
                <div className="absolute bottom-6 right-6 font-mono text-[10px] tracking-[0.2em] text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <MapPin className="size-3 text-primary" />
                    <span>BROOKLYN · NY</span>
                  </div>
                </div>

                {}
                <div className="absolute bottom-6 left-6 font-mono text-[10px] tracking-widest text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <div className="h-px w-12 bg-primary" />
                    <span>50m_SCALE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}